module.exports = __webpack_public_path__ + "img/visa-card-logo.6dd08e8f.svg";